import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/todo-due-date-cell.scss';

Component('tr-grid-todo-due-date-cell', {
  mixins: [baseMixin],

  properties: {
    editable: {
      type: Boolean,
      default: true,
      observer(editable) {
        if (this.editorInitialized && this.editor) {
          this.editor.disabled = !editable;
        }
      },
    },
  },

  connected() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-todo-date-field:change': this.handleChange.bind(this),
      'tr-date-picker-field-list:opened': () => { this.editing = true; },
      'tr-date-picker-field-list:closed': () => { this.editing = false; },
    });
  },

  preventClickEvent({ target }) {
    return this.editable
      && closest(target, '.tr-todo-date-field', this);
  },

  handleClick({ target }) {
    const field = closest(target, '.tr-todo-date-field', this);
    if (field && !field.classList.contains('grid-cell-editor')) {
      this.beginEditing();
    }
  },

  async beginEditing() {
    if (!this.editable || this.editing) return;

    await this.prepareEditor();
    if (!this.editor) return;

    this.editor.list.open();
  },

  setValue(value) {
    this.value = value;

    if (this.editorInitialized) {
      this.editor.setValue(value);
    } else {
      this.prepareEditor();
    }
  },

  prepareEditor() {
    return new Promise(async (resolve) => {
      if (this.editorInitialized) {
        resolve();
      } else {
        this.editor = await this.editorLoader.editor;
        this.editorInitialized = true;
        if (!this.editor) {
          resolve();
          return;
        }

        if (!this.editable) {
          this.editor.disabled = true;
        }

        if (this.value) {
          this.editor
            .querySelector('.native-control-wrapper input').value = this.value;
        }

        const readableDatetime = this.querySelector('tr-readable-datetime');
        if (readableDatetime.format) {
          this.editor.querySelector('tr-todo-date-field-result').shortened = true;
        }

        this.listenTo(this.editor, 'tao:ready', resolve, { once: true });
        this.replaceChild(this.editor, this.firstElementChild);
      }
    });
  },

  handleChange(event) {
    this.value = event.detail;
    this.namespacedTrigger('cellValueChange', {
      detail: { value: event.detail },
      bubbles: true,
    });
  },

  toggleMinimalStatus(minimal) {
    this.editable = !minimal;
    const readableDatetime = this.querySelector('tr-readable-datetime');
    readableDatetime.format = minimal && this.value
      && this.value.split(',').length === 2 ? 'MM/DD' : '';
  },
});
